const ROUTE_PREFIX = process.env.REACT_APP_ROUTE_PREFIX || "";

export const ROUTES = {
	HOME: `${ROUTE_PREFIX}/`,
	FAQ: `${ROUTE_PREFIX}/faq`,
	CONTACT: `${ROUTE_PREFIX}/contact`,
	ABOUT: `${ROUTE_PREFIX}/about`,
	PRODUCTS: `${ROUTE_PREFIX}/products`,
	PRODUCT_DETAILS: `${ROUTE_PREFIX}/products/:productId`,
} as const;

export const ROUTE_PATHS = Object.values(ROUTES);
